import React, { useState, useEffect } from "react";
import NeoButton from "../components/NeoButton";
import { useNavigate } from "react-router-dom";
import { Box, Grid, Typography, Button } from "@mui/material";
import { MainContext } from "../App";
import bg from "../@shared/assets/deckbuilderbg.png";
import { db } from "../@shared/firebase/config";
import { useAuthStore } from "../@shared/store/useAuthStore";
import { Add, ArrowBackIos, Delete, Edit } from "@mui/icons-material";
import { deleteDeckFromFirebase } from "../@shared/game/deckEngine";

const MyDecksScreen = ({
  decks,
  reset,
  setScreen,
  setSelectedDeckID,
  selectedDeckID,
  setNewDeck,
  setDeckName,
  setSelectedCharacter,
}) => {
  const { Theme } = React.useContext(MainContext);
  const { userData } = useAuthStore();

  const navigate = useNavigate();

  return (
    <Grid
      container
      item
      xs={12}
      sx={{
        justifyContent: "center",
        height: "100%",
        backgroundImage: `url(${bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        overflow: "hidden",
        position: "relative",
      }}
    >
      {/* HEADER */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          mb: 3,
          backgroundColor: Theme.palette.primary.main,
          borderBottom: `5px solid ${Theme.palette.primary.dark}`,
          borderTop: `5px solid ${Theme.palette.primary.light}`,
          position: "relative",
          width: "100%",
          pt: 2,
          pb: 2,
          height: "50px",
        }}
      >
        <Box
          style={{
            position: "absolute",
            top: "50%",
            left: "2%",
            transform: "translate(0%, -50%)",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <NeoButton
            isIcon={true}
            icon={
              <ArrowBackIos
                style={{
                  color: Theme.palette.text.main,
                  fontSize: "1.5rem",
                  paddingLeft: "10px",
                }}
              />
            }
            borderRadius={10}
            onClick={() => setScreen("Cards")}
            color={Theme.palette.tirciary.main}
          />
        </Box>

        <Typography
          variant="h3"
          sx={{
            fontWeight: "bold",
            fontSize: { xs: "2rem", md: "3rem" },
            position: "relative",
            color: Theme.palette.text.main,
            textShadow: ` -2px -2px 0 ${Theme.palette.tirciary.dark}, 2px -2px 0 ${Theme.palette.tirciary.dark}, -2px  2px 0 ${Theme.palette.tirciary.dark}, 2px  2px 0 ${Theme.palette.tirciary.dark}`,
          }}
        >
          Decks
        </Typography>

        <Box
          sx={{
            position: "absolute",
            top: "50%",
            right: "2%",
            transform: "translate(0%, -50%)",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            width: { xs: "100px", md: "150px" },
          }}
        >
          <NeoButton
            onClick={() => setScreen("Build")}
            width={100}
            text="Build"
            color={Theme.palette.tirciary.main}
          />
        </Box>
      </Box>

      {/* Decks Grid Wrapper */}
      <Grid item xs={12}>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          {/* Container fixed to 600px for a two-column layout */}
          <Grid
            container
            spacing={2}
            sx={{ width: 600, position: "relative", left: { xs: -15, md: 0 } }}
          >
            {decks.length < 4 && (
              <Grid
                item
                xs={6}
                sm={6}
                sx={{ display: "flex", justifyContent: "center" }}
              >
                <Box
                  sx={{
                    position: "relative",
                    backgroundColor: "rgb(58, 58, 58)",
                    height: { xs: 100, md: 150 },
                    width: { xs: 100, md: 300 },
                    borderRadius: 2,
                    p: 2,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0px 4px 8px rgba(255, 254, 254, 0.5)",
                    border: "10px solid rgba(255, 255, 255, 0.4)",
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      color: "#fff",
                      fontWeight: 900,
                      fontSize: { xs: "1.2rem", md: "1.5rem" },
                    }}
                  >
                    New Deck
                  </Typography>
                  {/* Only show the remove button for real decks */}

                  <NeoButton
                    onClick={() => {
                      setScreen("Build");
                    }}
                    isIcon={true}
                    icon={<Add />}
                    color={Theme.palette.primary.main}
                  />
                </Box>
              </Grid>
            )}
            {decks?.map((deck) => (
              <Grid
                item
                container
                xs={6}
                sm={6}
                key={deck.id}
                sx={{ display: "flex", justifyContent: "center", padding: 1 }}
              >
                <Box
                  sx={{
                    position: "relative",
                    backgroundColor: "rgb(58, 58, 58)",
                    height: { xs: "46dvw", md: 200 },
                    width: { xs: "46dvw", md: 300 },
                    borderRadius: 2,
                    p: { xs: 0, md: 2 },
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0px 4px 8px rgba(255, 254, 254, 0.5)",
                    border: "10px solid rgba(255, 255, 255, 0.4)",
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      color: "#fff",
                      fontWeight: 900,
                      fontSize: { xs: "1.2rem", md: "1.5rem" },
                    }}
                  >
                    {deck?.name ?? "Untitled Deck"}
                  </Typography>
                  {/* Only show the remove button for real decks */}
                  <Grid
                    item
                    xs={12}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: 4,
                    }}
                  >
                    <Box
                      style={{
                        position: "relative",
                        width: 80,
                        height: 100,
                      }}
                    >
                      <img
                        src={require("../@shared/assets/deck-box.png")}
                        style={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          width: "100%",
                          height: "100%",
                          marginBottom: 10,
                          resizeMode: "contain",
                          zIndex: 1,
                        }}
                      />

                      <Box
                        style={{
                          position: "absolute",
                          width: "91%",
                          height: "60%",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor: deck?.color ? deck.color : "#ef169c",
                          zIndex: 0,
                        }}
                      />
                    </Box>

                    <Box
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        position: "absolute",
                        width: "100%",
                        bottom: 0,
                        left: 0,
                        // marginTop: 40,
                      }}
                    >
                      <NeoButton
                        onClick={() => {
                          setSelectedDeckID(deck.id);
                          setNewDeck(deck.cards);
                          setDeckName(deck.name ?? "Untitled Deck");
                          setSelectedCharacter(deck.character);
                          setScreen(`Build`);
                        }}
                        isIcon={true}
                        icon={
                          <Edit style={{ color: Theme.palette.text.main }} />
                        }
                        color={Theme.palette.primary.main}
                      />
                      <NeoButton
                        onClick={() =>
                          deleteDeckFromFirebase(userData, deck.id, reset())
                        }
                        isIcon={true}
                        icon={
                          <Delete style={{ color: Theme.palette.text.main }} />
                        }
                        color={Theme.palette.secondary.main}
                      />
                    </Box>
                  </Grid>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Grid>
    </Grid>
  );
};

export default MyDecksScreen;
